import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Pagination,
  Modal,
  Select,
  DatePicker,
  format_date,
  params,
  GET,
  POST,
  PUT,
  DELETE,
  t,
} from "../../components/CustomComponent.js";
import { withRouter } from "../../components/withRouter.js";
import { getProfile } from "../../utils/localStorage.js";
import { initials, avatarTone, fmtPhone, isPartnerUser } from "../../components/people_option.js";
import { typeMeta as propTypeMeta } from "../../components/asset_option.js";
import {
  APPOINTMENT_TYPES,
  APPOINTMENT_STATUSES,
  apptTypeMeta,
  apptStatusMeta,
} from "../../components/customer_option.js";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
import "../../assets/css/crm.css";

/* ============================================================================
 * นัดหมาย  (/ad/appointments)
 * ตารางนัดพาลูกค้าเข้าชมทรัพย์ — ต่อยอดจากเมนูลูกค้า : ทุกนัดต้องผูกกับลูกค้า
 * ที่ติดต่อเข้ามาแล้ว 1 ราย และทรัพย์ที่ลูกค้าสนใจ 1 รายการ
 *
 * มี 2 มุมมอง : รายการ (ค่าเริ่มต้น) / ปฏิทินรายเดือน
 * เข้าหน้านี้พร้อม ?customer=<uid> จากหน้าลูกค้า = เปิดฟอร์มนัดหมายให้ทันที
 *
 * ข้อมูลจริงทั้งหน้า (ไม่มี mock แล้ว) :
 *   GET    admin/appointments          รายการ + ตัวกรอง (page 0 = ทั้งเดือน สำหรับปฏิทิน)
 *   GET    admin/appointments/summary  การ์ดสรุปหัวหน้า
 *   GET    admin/appointments/conflict เช็กนัดชนของผู้ดูแลก่อนบันทึก
 *   POST   admin/appointments          สร้างนัด
 *   PUT    admin/appointments/:uid     แก้ไข / เปลี่ยนสถานะ / ลากเลื่อนวันในปฏิทิน
 *   DELETE admin/appointments/:uid     ลบนัด
 * ตัวเลือกที่ต้องใช้ในฟอร์มดึงจากข้อมูลจริงเช่นกัน :
 *   GET admin/customers (ลูกค้า) · GET admin/assets (ทรัพย์) · GET admin/users (ผู้ดูแล)
 *
 * การกรอง เรียงลำดับ และแบ่งหน้า ทำที่ฝั่ง API ทั้งหมด — ปฏิทินขอทีละเดือน
 * ส่วนมุมมองรายการขอทีละหน้า จึงไม่ต้องดึงนัดทั้งระบบมาไว้ในเบราว์เซอร์
 * ========================================================================== */

const PAGE_SIZE = 10;
const MAX_EVENT_PER_CELL = 4; // เกินจากนี้ยุบเป็น "+N" กันช่องปฏิทินยืดจนเสียโครง
const EMPTY_FILTER = { keyword: "", status: "", type: "" };

/* ตัวเลือกการเรียงลำดับ — value ต้องตรงกับ SORT_ORDERS ใน appointment.repository.js
   (มุมมองปฏิทินไม่ใช้ชุดนี้ เพราะต้องไล่ตามเวลาจริงเสมอ) */
const SORTS = [
  { value: "start_desc", label: "sort_appt_newest" },
  { value: "start_asc", label: "sort_appt_oldest" },
  { value: "created_desc", label: "sort_appt_created" },
  { value: "customer_asc", label: "sort_name" },
];

const EMPTY_SUMMARY = { total: 0, status: {}, month: 0, today: 0, pending: 0, confirmed: 0, done: 0, missed: 0 };

/* ค่าเริ่มต้นของฟอร์มนัดหมาย — คีย์วางให้ตรงกับ payload ที่ส่งให้ API
   (date/time แยกกันเฉพาะในฟอร์ม ตอนส่งจะรวมเป็น start_at เดียว) */
const EMPTY_FORM = {
  customer_uid: "",
  asset_uid: "",
  type: "viewing",
  status: "pending",
  date: null,
  time: "10:00",
  duration: 60,
  admin_uid: "",
  location: "",
  note: "",
  reminded: true,
};

const DURATIONS = [30, 45, 60, 90, 120];
const QUICK_SLOTS = ["09:00", "09:30", "10:00", "10:30", "11:00", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00"];

/* ------------------------------------------------------------ วันที่/ภาษา */
const TH_MONTH_FULL = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"];
const EN_MONTH_FULL = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const TH_DOW = ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."];
const EN_DOW = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");
const num = (value) => Number(value || 0).toLocaleString("en-US");
const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
const addDays = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);
const sameDay = (a, b) => !!a && !!b && startOfDay(new Date(a)).getTime() === startOfDay(new Date(b)).getTime();
const TODAY = startOfDay(new Date());

const monthTitle = (d) => (isTh() ? `${TH_MONTH_FULL[d.getMonth()]} ${d.getFullYear() + 543}` : `${EN_MONTH_FULL[d.getMonth()]} ${d.getFullYear()}`);
const dateText = (value) => (value ? format_date(value, "dd mmm yyyy", locale()) : "-");
const pad = (n) => String(n).padStart(2, "0");
const timeText = (date) => `${pad(new Date(date).getHours())}:${pad(new Date(date).getMinutes())}`;
const rangeText = (item) => `${timeText(item.start_at)} - ${timeText(item.end_at)}`;

/* นัดหมายจาก API — วันเวลามาเป็นสตริง ISO แต่ทั้งหน้าคำนวณด้วย Date (เทียบวัน เรียงเวลา
   ลากวางในปฏิทิน) จึงแปลงให้เสร็จตั้งแต่รับเข้ามา ที่เหลือจะได้ไม่ต้องคอยแปลงซ้ำ */
const normalizeAppointment = (item) => ({
  ...item,
  start_at: new Date(item.start_at),
  end_at: new Date(item.end_at),
});

/* ทรัพย์จาก GET admin/assets — ย่อให้เหลือเท่าที่ฟอร์มนัดหมายต้องใช้
   วางโครงให้ตรงกับ interested ที่ API ลูกค้าส่งมา จะได้ใช้ตัวช่วยชุดเดียวกันทั้งสองทาง */
const normalizeAsset = (item) => ({
  uid: item.uid,
  code: item.code || "",
  title: item.headline || item.title || item.project || "",
  // ชื่อฟิลด์ทำเลใช้ zone เหมือนฝั่งลูกค้า (assets เก็บเป็น district)
  zone: item.district || "",
  type: item.type || "",
  address: item.address || "",
  status: item.status || "available",
  created_at: item.created_at || null,
});

/* บัญชีพาร์ตเนอร์ที่ล็อกอินอยู่ — พาร์ตเนอร์พาลูกค้าที่ตัวเองดูแลไปชมทรัพย์เอง
   ช่อง "ผู้ดูแล / แอดมิน" ของนัดจึงล็อกไว้ที่ชื่อตัวเอง ตั้งเป็นทีมงานคนอื่นไม่ได้
   (ล็อกแบบเดียวกับฟอร์มเพิ่มลูกค้าในหน้า /ad/customers)
   คืน null เมื่อเป็นผู้ใช้ภายใน — ยังเลือกได้ตามปกติ
   นี่เป็นแค่ UX เหมือน can() ด่านจริงต้องอยู่ฝั่ง backend */
const partnerSelf = () => {
  const me = getProfile();
  return isPartnerUser(me) ? me : null;
};

class Appointments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appointments: [],                     // นัดของหน้าปัจจุบัน (รายการ) หรือทั้งเดือน (ปฏิทิน)
      summary: { ...EMPTY_SUMMARY },        // การ์ดสรุป (มาจาก API)
      count: 0,

      customers: [],                        // ลูกค้า (GET admin/customers)
      assets: [],                           // ทรัพย์ที่เลือกได้ในฟอร์ม (GET admin/assets)
      admins: [],                           // ผู้ดูแล/แอดมิน (GET admin/users)

      filter: { ...EMPTY_FILTER },   // ตัวกรองในฟอร์ม (ยังไม่กดค้นหา)
      applied: { ...EMPTY_FILTER },  // ตัวกรองที่ใช้กับผลลัพธ์ปัจจุบัน
      sort: "start_desc",
      view: "list",                         // list | month
      cursor: new Date(TODAY.getFullYear(), TODAY.getMonth(), 1), // เดือนที่กำลังแสดง
      selected: TODAY,                      // วันที่เลือกในปฏิทิน (แผงใต้ปฏิทิน)
      page: 1,

      modal_form: false,
      modal_view: false,
      edit_uid: "",                         // ว่าง = โหมดสร้างนัดใหม่
      view_uid: "",
      form: { ...EMPTY_FORM },

      drag_uid: "",                         // นัดที่กำลังถูกลาก
      drag_over: null,                      // วันที่เมาส์ลากค้างอยู่
      moved_uid: "",                        // นัดที่เพิ่งย้าย (ใช้เล่น effect ไฮไลต์)
    };
  }

  componentDidMount() {
    loading(false);
    this.GetMaster();
    this.Get(1);
  }

  componentWillUnmount() {
    clearTimeout(this.move_timer);
  }

  /* ------------------------------------------------- ตัวเลือกจากข้อมูลจริง */
  /* ลูกค้า / ทรัพย์ / ผู้ดูแล — ดึงทีเดียวตอนเข้าหน้าเพื่อใช้เป็นตัวเลือกในฟอร์ม
     page: 0 = เอาทั้งหมดไม่แบ่งหน้า (เป็นรายการตัวเลือก ไม่ใช่ตาราง) */
  GetMaster = async () => {
    const [customers, assets, users] = await Promise.all([
      GET("admin/customers", { page: 0 }),
      GET("admin/assets", { page: 0 }),
      GET("admin/users", { page: 0, is_active: true }),
    ]);

    this.setState(
      {
        customers: customers?.status ? customers.data || [] : [],
        assets: assets?.status ? (assets.data || []).map(normalizeAsset).filter((e) => e.uid) : [],
        admins: users?.status ? users.data || [] : [],
      },
      () => {
        // มาจากหน้าลูกค้า (ปุ่ม "นัดชมทรัพย์") — เปิดฟอร์มพร้อมข้อมูลลูกค้ารายนั้น
        // ต้องรอตัวเลือกโหลดเสร็จก่อน ไม่งั้นฟอร์มเติมทรัพย์/ผู้ดูแลให้ไม่ได้
        const customer_uid = params("customer");
        if (customer_uid && this.customerOf(customer_uid)) this.OpenCreate(TODAY, customer_uid);
      }
    );
  };

  /* ---------------------------------------------------- ตัวช่วยหาข้อมูลอ้างอิง */
  customerOf = (uid) => (uid ? this.state.customers.find((e) => e.uid === uid) || null : null);

  adminOf = (uid) => (uid ? this.state.admins.find((e) => e.uid === uid) || null : null);

  assetOf = (uid) => {
    if (!uid) return null;

    const asset = this.state.assets.find((e) => e.uid === uid);
    if (asset) return asset;

    // ทรัพย์ที่ลูกค้าสนใจแต่ไม่อยู่ในรายการที่เลือกได้แล้ว (เช่น ถูกเก็บเข้ากรุ)
    // ยังต้องแสดงได้ จึงใช้ก้อนที่ API ลูกค้าส่งมาแทน
    for (const customer of this.state.customers) {
      const interested = (customer.interested || []).find((e) => e.uid === uid);
      if (interested) return { ...interested, address: interested.address || "" };
    }

    return null;
  };

  /* ทรัพย์ที่เพิ่งเข้าระบบล่าสุด — ใช้เป็นค่าตั้งต้นเมื่อลูกค้ายังไม่มีทรัพย์ที่สนใจ */
  newestAsset = () =>
    [...this.state.assets].sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0))[0] || null;

  /* ทรัพย์ตัวล่าสุดของลูกค้า = รายการที่เพิ่มเข้ามาทีหลังสุด (API เรียง sequence ASC มาให้)
     เลือกเปลี่ยนเป็นทรัพย์อื่นได้ทีหลังในช่อง "ทรัพย์" ของฟอร์ม */
  latestProperty = (customer) => {
    const interested = customer?.interested || [];
    for (let i = interested.length - 1; i >= 0; i--) {
      const asset = this.assetOf(interested[i]?.uid);
      if (asset) return asset;
    }
    return this.newestAsset();
  };

  /* ------------------------------------------------------------ ดึงนัดหมาย */
  /**
   * แปลงตัวกรองในหน้าเป็น query ของ API — คีย์ตรงกับที่ appointment.service อ่าน
   *
   * ต้องตัดคีย์ที่ไม่มีค่าออกก่อนส่ง เพราะ buildUrl ของ services/api.js ต่อ "ทุกคีย์"
   * ที่ส่งเข้าไปเป็น query string ค่าว่างจึงวิ่งไปถึงตัวกรองฝั่ง backend โดยไม่ตั้งใจ
   */
  query = (page = this.state.page, filter = this.state.applied, sort = this.state.sort) => {
    const { view, cursor } = this.state;

    const params = {
      data_search: filter.keyword,
      status: filter.status,
      type: filter.type,
      // ปฏิทินต้องเห็นนัดครบทั้งเดือนในคราวเดียว ส่วนตารางแบ่งหน้าที่ฝั่ง API
      ...(view === "month"
        ? { page: 0, sort: "start_asc", month: cursor.getMonth() + 1, year: cursor.getFullYear() }
        : { page, page_size: PAGE_SIZE, sort }),
    };

    return Object.fromEntries(
      Object.entries(params).filter(([, value]) => value !== "" && value !== null && value !== undefined)
    );
  };

  /* การ์ดสรุปใช้ตัวกรองชุดเดียวกับตาราง ยกเว้นสถานะ (backend ตัดออกให้เอง)
     เดือนที่ส่งไปคือเดือนที่ปฏิทินแสดงอยู่ — การ์ด "นัดเดือนนี้" จะได้ขยับตามที่ผู้ใช้เลื่อนดู */
  summaryQuery = (filter = this.state.applied) => {
    const { cursor } = this.state;

    const params = {
      data_search: filter.keyword,
      type: filter.type,
      month: cursor.getMonth() + 1,
      year: cursor.getFullYear(),
    };

    return Object.fromEntries(Object.entries(params).filter(([, value]) => value !== "" && value !== null));
  };

  Get = async (page = this.state.page, filter = this.state.applied, sort = this.state.sort) => {
    loading(true);
    const [result, summary] = await Promise.all([
      GET("admin/appointments", this.query(page, filter, sort)),
      GET("admin/appointments/summary", this.summaryQuery(filter)),
    ]);
    loading(false);

    if (!result?.status) return;

    const rows = (result.data || []).map(normalizeAppointment);

    // ลบรายการสุดท้ายของหน้าแล้วหน้านั้นว่าง — ถอยไปหน้าก่อนหน้าให้อัตโนมัติ
    if (!rows.length && this.state.view === "list" && page > 1) return this.Get(page - 1, filter, sort);

    this.setState({
      appointments: rows,
      count: result.pagination?.count ?? rows.length,
      page,
      // ตัวกรองที่ "ใช้กับผลลัพธ์ชุดนี้จริง ๆ" — เลื่อนเดือน/เปลี่ยนหน้าทีหลังจะได้ยึดชุดนี้
      // ไม่ใช่ชุดที่ผู้ใช้พิมพ์ค้างไว้ในฟอร์มแต่ยังไม่ได้กดค้นหา
      applied: { ...filter },
      sort,
      summary: summary?.status ? { ...EMPTY_SUMMARY, ...summary.data } : this.state.summary,
    });
  };

  /* -------------------------------------------------------------- ตัวกรอง */
  /* แก้ค่าในฟอร์มเฉย ๆ ยังไม่ยิง API — ผลลัพธ์เปลี่ยนตอนกดปุ่มค้นหาเท่านั้น */
  setFilter = (patch) => this.setState((prev) => ({ filter: { ...prev.filter, ...patch } }));

  Search = () => this.Get(1, this.state.filter);

  clearFilters = () => this.setState({ filter: { ...EMPTY_FILTER } }, () => this.Get(1, { ...EMPTY_FILTER }));

  switchView = (view) => this.setState({ view, page: 1 }, () => this.Get(1));

  /* นัดของวันหนึ่ง เรียงตามเวลาเริ่ม */
  ofDay = (date) =>
    this.state.appointments.filter((e) => sameDay(e.start_at, date)).sort((a, b) => a.start_at - b.start_at);

  /* --------------------------------------------------------- ย้ายเดือน/วัน */
  shiftMonth = (n) =>
    this.setState(
      (prev) => ({ cursor: new Date(prev.cursor.getFullYear(), prev.cursor.getMonth() + n, 1) }),
      () => this.Get(1)
    );

  goToday = () =>
    this.setState({ cursor: new Date(TODAY.getFullYear(), TODAY.getMonth(), 1), selected: TODAY }, () => this.Get(1));

  selectDay = (date) => this.setState({ selected: startOfDay(date) });

  /* --------------------------------------------------- เปิดฟอร์ม สร้าง/แก้ไข */
  OpenCreate = (date = this.state.selected, customer_uid = "") => {
    const customer = this.customerOf(customer_uid);
    const property = customer ? this.latestProperty(customer) : null;
    this.setState({
      modal_form: true,
      modal_view: false,
      edit_uid: "",
      form: {
        ...EMPTY_FORM,
        customer_uid,
        asset_uid: property?.uid || "",
        // พาร์ตเนอร์ล็อกไว้ที่ตัวเอง ไม่รับผู้ดูแลที่ติดมากับลูกค้า (ช่องนี้แก้ไม่ได้)
        admin_uid: partnerSelf()?.uid || customer?.admin_uid || "",
        location: property?.address || "",
        date: startOfDay(date || TODAY),
      },
    });
  };

  OpenEdit = (item) => {
    this.setState({
      modal_form: true,
      modal_view: false,
      edit_uid: item.uid,
      form: {
        customer_uid: item.customer_uid,
        asset_uid: item.asset_uid,
        type: item.type,
        status: item.status,
        date: startOfDay(item.start_at),
        time: timeText(item.start_at),
        duration: item.duration,
        // นัดเก่าที่ยังไม่มีผู้ดูแล : พาร์ตเนอร์ได้ชื่อตัวเองเติมให้ (ช่องถูกล็อก)
        admin_uid: item.admin_uid || partnerSelf()?.uid || "",
        location: item.location || "",
        note: item.note || "",
        reminded: !!item.reminded,
      },
    });
  };

  OpenView = (item) => this.setState({ modal_view: true, view_uid: item.uid });

  current = () => this.state.appointments.find((e) => e.uid === this.state.view_uid);

  setForm = (patch) => this.setState((prev) => ({ form: { ...prev.form, ...patch } }));

  // เลือกลูกค้า → เติมทรัพย์ตัวล่าสุดที่ลูกค้าสนใจ ผู้ดูแล และสถานที่ให้อัตโนมัติ
  pickCustomer = (customer_uid) => {
    const customer = this.customerOf(customer_uid);
    const property = customer ? this.latestProperty(customer) : null;
    this.setForm({
      customer_uid,
      asset_uid: property?.uid || "",
      // พาร์ตเนอร์ยังเป็นผู้ดูแลนัดของตัวเอง แม้ลูกค้ารายนั้นจะมีคนอื่นดูแลอยู่
      admin_uid: partnerSelf()?.uid || customer?.admin_uid || this.state.form.admin_uid,
      location: property?.address || this.state.form.location,
    });
  };

  pickProperty = (asset_uid) => {
    const property = this.assetOf(asset_uid);
    this.setForm({ asset_uid, location: property?.address || "" });
  };

  /* ทรัพย์ที่เลือกได้ในฟอร์ม — ทรัพย์ที่ลูกค้าสนใจขึ้นก่อน (ล่าสุดอยู่บนสุด ตรงกับ
     ค่าที่เติมให้อัตโนมัติ) แล้วต่อด้วยทรัพย์อื่นทั้งหมดในระบบ */
  propertyOptions = () => {
    const customer = this.customerOf(this.state.form.customer_uid);
    const liked = [...(customer?.interested || [])]
      .reverse()
      .map((entry) => this.assetOf(entry?.uid))
      .filter(Boolean);
    const rest = this.state.assets.filter((p) => !liked.some((e) => e.uid === p.uid));
    return [
      ...liked.map((p) => ({ value: p.uid, label: `★ ${p.title} (${p.code})` })),
      ...rest.map((p) => ({ value: p.uid, label: `${p.title} (${p.code})` })),
    ];
  };

  customerOptions = () => this.state.customers.map((c) => ({ value: c.uid, label: `${c.name} (${c.code})` }));

  adminOptions = () => this.state.admins.map((a) => ({ value: a.uid, label: a.full_name }));

  /* ------------------------------------------------------------ บันทึกนัด */
  Save = async () => {
    const { form, edit_uid } = this.state;
    const customer = this.customerOf(form.customer_uid);
    const property = this.assetOf(form.asset_uid);

    if (!customer) return alert("", "warning", t("warning"), t("verify_customer"));
    if (!property) return alert("", "warning", t("warning"), t("verify_property"));
    if (!form.date) return alert("", "warning", t("warning"), t("verify_appointment_date"));
    if (!/^\d{2}:\d{2}$/.test(form.time)) return alert("", "warning", t("warning"), t("verify_appointment_time"));
    if (!form.admin_uid) return alert("", "warning", t("warning"), t("verify_agent"));

    const [hour, minute] = form.time.split(":").map(Number);
    const base = startOfDay(new Date(form.date));
    const start_at = new Date(base.getFullYear(), base.getMonth(), base.getDate(), hour, minute);
    const duration = Number(form.duration) || 60;
    const end_at = new Date(start_at.getTime() + duration * 60000);

    /* เตือนเมื่อผู้ดูแลคนเดียวกันมีนัดคาบเกี่ยวกันในช่วงเวลานั้น
       ต้องถามจาก API ไม่ใช่ไล่ดูนัดที่โหลดมา เพราะนัดที่ชนอาจอยู่คนละเดือน/คนละหน้า */
    const conflict = await GET("admin/appointments/conflict", {
      admin_uid: form.admin_uid,
      start_at: start_at.toISOString(),
      end_at: end_at.toISOString(),
      ...(edit_uid ? { uid: edit_uid } : {}),
    });

    if (conflict?.status && conflict.data) {
      const clash = normalizeAppointment(conflict.data);
      const proceed = await alert(
        "",
        "warning",
        t("schedule_conflict"),
        `${t("schedule_conflict_desc")}\n${clash.customer_name} · ${rangeText(clash)}`,
        t("confirm"),
        t("cancel")
      );
      if (!proceed) return;
    }

    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    const payload = {
      customer_uid: form.customer_uid,
      asset_uid: form.asset_uid,
      admin_uid: form.admin_uid,
      type: form.type,
      status: form.status,
      // ส่งเป็น ISO เสมอ — เวลาที่ผู้ใช้เห็นเป็นเวลาเครื่อง เบราว์เซอร์แปลงกลับให้ตรงกันเอง
      start_at: start_at.toISOString(),
      duration,
      location: (form.location || "").trim(),
      note: form.note || "",
      reminded: !!form.reminded,
    };

    loading(true);
    const result = !edit_uid ? await POST("admin/appointments", payload) : await PUT("admin/appointments/" + edit_uid, payload);
    loading(false);

    if (!result?.status) return;

    // เด้งไปยังเดือน/วันของนัดที่เพิ่งบันทึก เพื่อให้เห็นผลทันที
    this.setState(
      {
        modal_form: false,
        selected: startOfDay(start_at),
        cursor: new Date(start_at.getFullYear(), start_at.getMonth(), 1),
      },
      () => {
        this.Get(1);
        alert("", "success", t("success"), edit_uid ? t("save_done") : t("add_appointment_done"));
      }
    );
  };

  Delete = async (item) => {
    if (!item) return;
    if (!(await alert("", "warning", t("delete_item"), `${t("delete_appointment_desc")}\n${item.customer_name} · ${dateText(item.start_at)}`, t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await DELETE("admin/appointments/" + item.uid, null);
    loading(false);

    if (!result?.status) return;

    this.setState({ modal_view: false, modal_form: false }, () => {
      this.Get();
      alert("", "success", t("success"), t("delete_done"));
    });
  };

  GoCustomer = (item) => {
    this.setState({ modal_view: false });
    this.props.router.navigate(`/ad/customers?uid=${item.customer_uid}`);
  };

  /* ------------------------------------------------ ลากวางเปลี่ยนวันนัดในปฏิทิน */
  onDragStart = (item, e) => {
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", item.uid); // Firefox ต้องมี data ถึงจะเริ่มลากได้
    this.setState({ drag_uid: item.uid });
  };

  onDragEnd = () => this.setState({ drag_uid: "", drag_over: null });

  onDragOverCell = (date, e) => {
    if (!this.state.drag_uid) return;
    e.preventDefault(); // ต้อง preventDefault ถึงจะวางลงช่องนี้ได้
    e.dataTransfer.dropEffect = "move";
    if (!sameDay(this.state.drag_over, date)) this.setState({ drag_over: startOfDay(date) });
  };

  onDropCell = (date, e) => {
    e.preventDefault();
    const uid = this.state.drag_uid || e.dataTransfer.getData("text/plain");
    this.setState({ drag_uid: "", drag_over: null });
    this.MoveAppointment(uid, date);
  };

  /* ย้ายไปวันใหม่โดยคงเวลาและระยะเวลาเดิม (ปรับเวลาต่อได้ในฟอร์มแก้ไข) */
  MoveAppointment = async (uid, date) => {
    const item = this.state.appointments.find((e) => e.uid === uid);
    if (!item || sameDay(item.start_at, date)) return;

    const base = startOfDay(date);
    const start_at = new Date(
      base.getFullYear(), base.getMonth(), base.getDate(),
      item.start_at.getHours(), item.start_at.getMinutes()
    );

    // ยืนยันก่อนย้ายจริง — ลากพลาดในปฏิทินเกิดขึ้นได้ง่าย และการเลื่อนนัดกระทบลูกค้า
    const summary = `${item.customer_name} · ${item.asset_title}`;
    const change = `${dateText(item.start_at)} ${timeText(item.start_at)}  →  ${dateText(start_at)} ${timeText(start_at)}`;
    if (!(await alert("", "info", t("move_appointment"), `${t("move_appointment_confirm")}\n${summary}\n${change}`, t("confirm"), t("cancel")))) return;

    loading(true);
    // ส่งแค่ start_at — ฝั่ง API คำนวณเวลาจบใหม่จากระยะเวลาเดิมให้เอง
    const result = await PUT("admin/appointments/" + uid, { start_at: start_at.toISOString() });
    loading(false);

    if (!result?.status) return;

    clearTimeout(this.move_timer);
    this.setState(
      {
        selected: base,
        cursor: new Date(base.getFullYear(), base.getMonth(), 1),
        moved_uid: uid, // ติดคลาสไว้ให้ CSS ไฮไลต์ช่องปลายทางสักครู่
      },
      () => {
        this.Get();
        this.move_timer = setTimeout(() => this.setState({ moved_uid: "" }), 1400);
        alert("", "success", t("success"), t("move_appointment_done"));
      }
    );
  };

  /* ================================================== render : การ์ดสรุปตัวเลข */
  renderSummary = () => {
    const s = this.state.summary;
    const cards = [
      { label: "appointments_this_month", value: s.month, hint: monthTitle(this.state.cursor), raw_hint: true, icon: "", color: "#4d7c0f", tint: "#eaf9d2" },
      { label: "appointments_today", value: s.today, hint: "appt_today_hint", icon: "", color: "#4d7c0f", tint: "#eaf9d2" },
      { label: "appt_pending", value: s.pending, hint: "appt_pending_hint", icon: "", color: "#b45309", tint: "#fef3c7" },
      { label: "appt_confirmed", value: s.confirmed, hint: "appt_confirmed_hint", icon: "", color: "#0369a1", tint: "#e0f2fe" },
      { label: "appt_done", value: s.done, hint: "appt_done_hint", icon: "", color: "#15803d", tint: "#dcfce7" },
      { label: "appt_missed", value: s.missed, hint: "appt_missed_hint", icon: "", color: "#9f1239", tint: "#ffe4e6" },
    ];

    return (
      <div className="row g-3 mb-3">
        {cards.map((card, i) => (
          <div className="col-xl-2 col-lg-4 col-sm-6" key={i}>
            <div className="crm-stat prop-in">
              <span className="crm-stat__edge" style={{ backgroundColor: card.color }} />
              <span className="crm-stat__icon icon" style={{ backgroundColor: card.tint, color: card.color }}>
                {card.icon}
              </span>
              <div className="min-w-0">
                <div className="crm-stat__label text-truncate">{t(card.label)}</div>
                <div className="crm-stat__value">{num(card.value)}</div>
                <div className="crm-stat__hint text-truncate">{card.raw_hint ? card.hint : t(card.hint)}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  /* ================================================ render : ตัวกรองการค้นหา */
  /* แก้ค่าในนี้แล้วผลลัพธ์ยังไม่เปลี่ยนจนกว่าจะกดปุ่มค้นหา (หรือกด Enter ในช่องค้นหา) */
  renderToolbar = () => {
    const { filter } = this.state;

    const select = (key, options) => (
      <Select
        className="prop-field prop-select"
        default={false}
        placeholder={t("all")}
        value={filter[key]}
        options={[{ value: "", label: t("all") }, ...options]}
        onChange={(value) => this.setFilter({ [key]: value })}
      />
    );

    return (
      <div className="prop-card prop-in mb-3">
        <div className="prop-card__head py-3">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            <span className="icon me-1 text-12">{"\uf1de"}</span>
            {t("search_filters")}
          </span>
          <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={this.clearFilters}>
            <span className="icon text-12">{"\uf00d"}</span>
            {t("clear_filters")}
          </button>
        </div>

        <div className="p-4">
          <div className="row g-3">
            <div className="col-xl-4 col-md-6">
              <label className="prop-label">{t("search_appointment")}</label>
              <div className="position-relative">
                <span className="icon prop-field-icon">{"\uf002"}</span>
                <input
                  type="text"
                  className="prop-field prop-field--icon"
                  placeholder={t("search_appointment_placeholder")}
                  value={filter.keyword}
                  onChange={(e) => this.setFilter({ keyword: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && this.Search()}
                />
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("appointment_type")}</label>
              {select("type", APPOINTMENT_TYPES.map((e) => ({ value: e.value, label: t(e.label) })))}
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("status")}</label>
              {select("status", APPOINTMENT_STATUSES.map((e) => ({ value: e.value, label: t(e.label) })))}
            </div>

            {/* ปุ่มค้นหาแชร์บรรทัดเดียวกับช่องสุดท้าย — ชิดขวาสุดของแถว */}
            <div className="col-xl-2 col-md-6 d-flex align-items-end justify-content-md-end">
              <button type="button" className="prop-btn" onClick={this.Search}>
                <span className="icon text-14">{"\uf002"}</span>
                {t("search")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  /* ================================================= render : แถบผลการค้นหา */
  renderResults = () => {
    const { count, sort, view } = this.state;

    return (
      <div className="prop-card prop-in p-3 mb-3">
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
          <div>
            <span className="fw-bold text-dark">{t("search_results")}</span>
            <span className="fw-bold ms-2" style={{ color: "#4d7c0f" }}>{num(count)}</span>
            <span className="text-secondary text-12 ms-1">{t("unit_appointments")}</span>
          </div>

          <div className="d-flex flex-wrap align-items-center gap-2">
            {/* ปฏิทินไล่ตามเวลาจริงเสมอ การเรียงลำดับจึงมีผลเฉพาะมุมมองรายการ */}
            {view === "list" && (
              <>
                <span className="text-secondary text-12">{t("sort_by")}</span>
                <Select
                  className="prop-field prop-select wpx-220"
                  default={false}
                  placeholder={t("sort_by")}
                  value={sort}
                  options={SORTS.map((s) => ({ value: s.value, label: t(s.label) }))}
                  onChange={(value) => value && this.Get(1, this.state.applied, value)}
                />
              </>
            )}
            <div className="prop-toggle">
              <button
                type="button"
                title={t("month_view")}
                className={`prop-toggle__btn icon ${view === "month" ? "is-active" : ""}`}
                onClick={() => this.switchView("month")}
              >
                {"\uf073"}
              </button>
              <button
                type="button"
                title={t("list_view")}
                className={`prop-toggle__btn icon ${view === "list" ? "is-active" : ""}`}
                onClick={() => this.switchView("list")}
              >
                {"\uf03a"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  /* ============================================ render : กล่องนัดหมาย 1 รายการ */
  eventChip = (item) => {
    const { drag_uid, moved_uid } = this.state;
    const status = apptStatusMeta(item.status);
    const closed = item.status === "cancelled" || item.status === "no_show";
    // ขอบใช้สีสถานะแบบโปร่ง (hex 8 หลัก) แทนสีอ่อน กล่องจะได้ไม่จมไปกับพื้นช่อง
    const chipStyle = {
      backgroundColor: status.tint,
      borderColor: `${status.color}55`,
      borderLeftColor: status.color,
      color: status.color,
    };

    return (
      <button
        key={item.uid}
        type="button"
        draggable
        className={`crm-event ${closed ? "is-off" : ""} ${drag_uid === item.uid ? "is-dragging" : ""} ${
          moved_uid === item.uid ? "is-moved" : ""
        }`}
        title={`${rangeText(item)} · ${item.customer_name} · ${item.asset_title}`}
        style={chipStyle}
        onDragStart={(e) => this.onDragStart(item, e)}
        onDragEnd={this.onDragEnd}
        onClick={(e) => {
          e.stopPropagation();
          this.OpenView(item);
        }}
      >
        <span className="crm-event__time">{timeText(item.start_at)}</span>
        <span className="crm-event__name">{item.customer_name}</span>
      </button>
    );
  };

  apptCard = (item) => {
    const status = apptStatusMeta(item.status);
    const type = apptTypeMeta(item.type);
    const closed = item.status === "cancelled" || item.status === "no_show";
    return (
      <button key={item.uid} type="button" className={`crm-appt ${closed ? "is-off" : ""}`} onClick={() => this.OpenView(item)}>
        <span className="crm-appt__strip" style={{ backgroundColor: status.color }} />
        <div className="d-flex align-items-center justify-content-between gap-2">
          <span className="crm-appt__time">{rangeText(item)}</span>
          <span className="crm-badge" style={{ backgroundColor: status.tint, borderColor: status.line, color: status.color }}>
            {t(status.label)}
          </span>
        </div>
        <div className="crm-appt__name mt-1">{item.customer_name}</div>
        <div className="crm-appt__sub mt-1">
          <span className="icon text-10" style={{ color: type.color }}>{type.icon}</span>
          <span className="text-truncate">{item.asset_title}</span>
        </div>
        <div className="crm-appt__sub mt-1">
          <span className="icon text-10">{""}</span>
          <span className="text-truncate">{item.admin_name || "-"}</span>
        </div>
      </button>
    );
  };

  /* ================================================== render : ปฏิทินรายเดือน */
  monthCells = () => {
    const { cursor } = this.state;
    const first = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
    const start = addDays(first, -first.getDay()); // เริ่มที่วันอาทิตย์ของสัปดาห์แรก
    const last = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 0);
    const end = addDays(last, 6 - last.getDay()); // จบที่วันเสาร์ของสัปดาห์สุดท้าย
    const total = Math.round((end - start) / 86400000) + 1;
    return Array.from({ length: total }, (_, i) => addDays(start, i));
  };

  renderMonth = () => {
    const { cursor, selected, drag_over } = this.state;
    const dow = isTh() ? TH_DOW : EN_DOW;

    return (
      <div className="crm-cal prop-in">
        <div className="crm-cal__dow">
          {dow.map((d, i) => (
            <span key={i} className={i === 0 || i === 6 ? "is-weekend" : ""}>
              {d}
            </span>
          ))}
        </div>

        <div className="crm-cal__grid">
          {this.monthCells().map((date, i) => {
            const items = this.ofDay(date);
            const out = date.getMonth() !== cursor.getMonth();
            const weekend = date.getDay() === 0 || date.getDay() === 6;
            const shown = items.slice(0, MAX_EVENT_PER_CELL);
            const rest = items.length - shown.length;

            return (
              <div
                key={i}
                role="button"
                tabIndex={0}
                className={`crm-cell ${out ? "is-out" : ""} ${weekend ? "is-weekend" : ""} ${
                  sameDay(date, TODAY) ? "is-today" : ""
                } ${sameDay(date, selected) ? "is-selected" : ""} ${sameDay(drag_over, date) ? "is-drop" : ""}`}
                onClick={() => this.selectDay(date)}
                onKeyDown={(e) => e.key === "Enter" && this.selectDay(date)}
                onDragOver={(e) => this.onDragOverCell(date, e)}
                onDrop={(e) => this.onDropCell(date, e)}
              >
                <div className="crm-cell__head">
                  <span className={`crm-cell__no ${sameDay(date, TODAY) ? "is-today" : ""}`}>{date.getDate()}</span>
                  <span className="d-flex align-items-center gap-1">
                    {!!items.length && <span className="crm-cell__tally">{items.length}</span>}
                    {/* ปุ่มเพิ่มนัดของวันนั้น — โผล่ตอนชี้เมาส์ที่ช่อง */}
                    <button
                      type="button"
                      className="crm-cell__add icon"
                      title={t("add_on_this_day")}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.OpenCreate(date);
                      }}
                    >
                      {""}
                    </button>
                  </span>
                </div>
                {shown.map((item) => this.eventChip(item))}
                {rest > 0 && (
                  <button type="button" className="crm-more" onClick={(e) => { e.stopPropagation(); this.selectDay(date); }}>
                    +{rest} {t("more_items")}
                  </button>
                )}
              </div>
            );
          })}
        </div>

        {/* คำอธิบายสีสถานะ — วางใต้ปฏิทินเพื่อให้อ่านสีในช่องได้ทันที */}
        <div className="crm-legend">
          {APPOINTMENT_STATUSES.map((status) => (
            <span className="crm-legend__item" key={status.value}>
              <span className="crm-legend__swatch" style={{ backgroundColor: status.color }} />
              {t(status.label)}
            </span>
          ))}
        </div>
      </div>
    );
  };

  /* ============================================ render : นัดของวันที่เลือก */
  /* ย้ายมาไว้ใต้ปฏิทินแทนการเป็นคอลัมน์ขวา เพื่อให้ปฏิทินกว้างเต็มหน้า */
  renderDayPanel = () => {
    const { selected } = this.state;
    const items = this.ofDay(selected);

    return (
      <div className="prop-card prop-in mt-3">
        <div className="prop-card__head py-3">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {dateText(selected)}
            {sameDay(selected, TODAY) && <span className="crm-badge ms-1" style={{ backgroundColor: "#eaf9d2", borderColor: "#d5efab", color: "#3f5312" }}>{t("today")}</span>}
          </span>
          <div className="d-flex align-items-center gap-3">
            <span className="text-secondary text-12">
              {items.length} {t("unit_appointments")}
            </span>
            <button type="button" className="prop-btn prop-btn--sm" onClick={() => this.OpenCreate(selected)}>
              <span className="icon text-12">{""}</span>
              {t("add_appointment")}
            </button>
          </div>
        </div>
        <div className="p-3">
          {items.length ? (
            <div className="crm-daygrid">{items.map((item) => this.apptCard(item))}</div>
          ) : (
            <div className="text-center py-4">
              <div className="prop-empty__icon icon mx-auto" style={{ width: "52px", height: "52px", fontSize: "20px" }}>
                {""}
              </div>
              <div className="text-secondary text-12 mt-2">{t("no_appointment_this_day")}</div>
            </div>
          )}
        </div>
      </div>
    );
  };

  /* ================================================== render : มุมมองรายการ */
  renderList = () => {
    const { appointments: data, count, page } = this.state;
    const last_page = Math.max(1, Math.ceil(count / PAGE_SIZE));

    if (!count) {
      return (
        <div className="prop-card prop-in">
          <div className="prop-empty">
            <div className="prop-empty__icon icon">{""}</div>
            <div className="fw-bold text-dark mb-1">{t("no_appointments_found")}</div>
            <div className="text-12">{t("try_adjust_filters")}</div>
          </div>
        </div>
      );
    }

    return (
      <>
        <div className="prop-card prop-in">
          <div className="table-responsive" style={{ borderRadius: "18px" }}>
            <table className="ppl-table" style={{ minWidth: "1080px" }}>
              <thead>
                <tr>
                  <th style={{ width: "168px" }}>{t("appointment_date")}</th>
                  <th style={{ width: "150px" }}>{t("appointment_type")}</th>
                  <th style={{ width: "216px" }}>{t("customer_col")}</th>
                  <th style={{ width: "240px" }}>{t("property")}</th>
                  <th style={{ width: "150px" }}>{t("owner_admin")}</th>
                  <th style={{ width: "138px" }}>{t("status")}</th>
                  <th className="text-center" style={{ width: "128px" }}>{t("actions")}</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => {
                  const type = apptTypeMeta(item.type);
                  const status = apptStatusMeta(item.status);

                  return (
                    <tr key={item.uid}>
                      <td>
                        <div className="fw-bold text-dark">{dateText(item.start_at)}</div>
                        <div className="ppl-sub d-flex align-items-center gap-2 mt-1">
                          <span className="icon text-10">{""}</span>
                          {rangeText(item)}
                        </div>
                      </td>
                      <td>
                        <span className="crm-badge" style={{ backgroundColor: type.tint, borderColor: "transparent", color: type.color }}>
                          <span className="icon">{type.icon}</span>
                          {t(type.label)}
                        </span>
                        <div className="ppl-sub mt-1">{item.code}</div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center gap-3">
                          <div className="ppl-avatar ppl-avatar--sm" style={{ background: avatarTone(item.customer?.email || item.customer_name) }}>
                            {initials(item.customer_name)}
                          </div>
                          <div className="min-w-0">
                            <div className="ppl-name text-truncate">{item.customer_name}</div>
                            <div className="ppl-sub">{fmtPhone(item.customer_phone)}</div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center gap-3">
                          {/* รูปหลักของทรัพย์ — ยังไม่มีรูปจะขึ้นพื้นไล่เฉดตามประเภทแทน */}
                          <span
                            className="crm-prop__icon icon"
                            style={{ background: item.asset?.asset_category?.grad, overflow: "hidden", padding: 0 }}
                          >
                            {item.asset_image ? (
                              <img
                                src={item.asset_image}
                                alt={item.asset_title}
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                              />
                            ) : (
                              item.asset?.asset_category?.icon
                            )}
                          </span>
                          <div className="min-w-0">
                            <div className="text-truncate" style={{ maxWidth: "180px" }}>{item.asset_title}</div>
                            <div className="ppl-sub text-truncate" style={{ maxWidth: "180px" }}>
                              {item.asset_code} · {item.location}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <span className="icon text-secondary text-12">{""}</span>
                          <span className="text-truncate" style={{ maxWidth: "110px" }}>{item.admin_name || "-"}</span>
                        </div>
                      </td>
                      <td>
                        <span className="crm-badge" style={{ backgroundColor: status.tint, borderColor: status.line, color: status.color }}>
                          <span className="icon">{status.icon}</span>
                          {t(status.label)}
                        </span>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center gap-2">
                          <button type="button" className="prop-iconbtn icon" title={t("view_details")} onClick={() => this.OpenView(item)}>
                            {""}
                          </button>
                          <button type="button" className="prop-iconbtn prop-iconbtn--dark icon" title={t("edit")} onClick={() => this.OpenEdit(item)}>
                            {""}
                          </button>
                          <button
                            type="button"
                            className="prop-iconbtn icon"
                            style={{ borderColor: "#fecaca", color: "#b91c1c" }}
                            title={t("delete")}
                            onClick={() => this.Delete(item)}
                          >
                            {""}
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mt-4 text-secondary text-12">
          <div>
            {t("showing")} {(page - 1) * PAGE_SIZE + 1}-{Math.min(page * PAGE_SIZE, count)} {t("of")} {num(count)}{" "}
            {t("unit_appointments")}
          </div>
          <Pagination
            className="mb-0"
            page={page}
            count={last_page}
            showFirstButton={false}
            showLastButton={false}
            onChange={(_, next) => {
              this.Get(next);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          />
        </div>
      </>
    );
  };

  /* ====================================================== render : แถบเดือน */
  renderMonthBar = () => {
    const { cursor } = this.state;

    return (
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3 prop-in">
        <div className="crm-monthbar">
          <button
            type="button"
            className="crm-nav icon"
            aria-label={t("previous")}
            onClick={() => this.shiftMonth(-1)}
          >
            {""}
          </button>
          <span className="crm-month">{monthTitle(cursor)}</span>
          <button
            type="button"
            className="crm-nav icon"
            aria-label={t("next")}
            onClick={() => this.shiftMonth(1)}
          >
            {""}
          </button>
          <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm ms-1" onClick={this.goToday}>
            {t("today")}
          </button>
        </div>
        <div className="text-secondary text-12">{t("calendar_hint")}</div>
      </div>
    );
  };

  /* ============================================= render : ฟอร์ม สร้าง/แก้ไข */
  renderFormModal = () => {
    const { modal_form, edit_uid, form } = this.state;
    // ผู้ใช้ภายในได้ null — ช่องผู้ดูแลเป็น dropdown ตามปกติ
    const self = partnerSelf();
    const customer = this.customerOf(form.customer_uid);
    const property = this.assetOf(form.asset_uid);

    return (
      <Modal
        size="lg"
        show={modal_form}
        onHide={() => this.setState({ modal_form: false })}
        centered
        contentClassName="border-0 rounded-4 overflow-visible shadow-lg"
      >
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white">
          <div>
            <h5 className="fw-bold mb-0 text-dark">{edit_uid ? t("edit_appointment") : t("add_appointment")}</h5>
            <div className="text-secondary text-12">{t("appointment_form_desc")}</div>
          </div>
        </Modal.Header>

        <Modal.Body className="p-4 bg-white">
          {/* สรุปนัดแบบย่อ — เห็นผลทันทีระหว่างกรอก */}
          {!!customer && (
            <div
              className="d-flex align-items-center gap-3 p-3 mb-4 rounded-4"
              style={{ background: "linear-gradient(102deg,#eaf9d2,#f8fcef)", border: "1px solid #d5efab" }}
            >
              <div className="ppl-avatar ppl-avatar--lg" style={{ background: avatarTone(customer.email || customer.name) }}>
                {initials(customer.name)}
              </div>
              <div className="min-w-0">
                <div className="fw-bold text-dark text-16 text-truncate">{customer.name}</div>
                <div className="text-secondary text-12">{fmtPhone(customer.phone)} · {customer.code}</div>
                <div className="text-12 text-dark mt-1 text-truncate">
                  {property ? property.title : t("select_property")}
                  {form.date ? ` · ${dateText(form.date)} ${form.time}` : ""}
                </div>
              </div>
            </div>
          )}

          <div className="row g-3">
            <div className="col-md-6">
              <label className="prop-label">
                {t("customer")} <span className="text-danger">*</span>
              </label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("select_customer")}
                value={form.customer_uid}
                options={this.customerOptions()}
                onChange={(value) => value && this.pickCustomer(value)}
              />
            </div>
            <div className="col-md-6">
              <label className="prop-label">
                {t("property")} <span className="text-danger">*</span>
              </label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("select_property")}
                value={form.asset_uid}
                options={this.propertyOptions()}
                onChange={(value) => value && this.pickProperty(value)}
              />
            </div>

            <div className="col-12">
              <label className="prop-label">{t("appointment_type")}</label>
              <div className="prop-seg">
                {APPOINTMENT_TYPES.map((type) => (
                  <button
                    key={type.value}
                    type="button"
                    aria-pressed={form.type === type.value}
                    className={`prop-seg__btn ${form.type === type.value ? "is-active" : ""}`}
                    onClick={() => this.setForm({ type: type.value })}
                  >
                    <span className="icon me-1 text-10">{type.icon}</span>
                    {t(type.label)}
                  </button>
                ))}
              </div>
            </div>

            <div className="col-md-4 prop-datefield">
              <label className="prop-label">
                {t("appointment_date")} <span className="text-danger">*</span>
              </label>
              <DatePicker
                type="th"
                className="prop-field"
                value={form.date}
                onChange={(value) => this.setForm({ date: value ? new Date(value) : null })}
              />
            </div>
            <div className="col-md-4">
              <label className="prop-label">
                {t("start_time")} <span className="text-danger">*</span>
              </label>
              <input
                type="time"
                className="prop-field"
                value={form.time}
                onChange={(e) => this.setForm({ time: e.target.value })}
              />
            </div>
            <div className="col-md-4">
              <label className="prop-label">{t("duration")}</label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("duration")}
                value={form.duration}
                options={DURATIONS.map((d) => ({ value: d, label: `${d} ${t("unit_minutes")}` }))}
                onChange={(value) => value && this.setForm({ duration: value })}
              />
            </div>

            <div className="col-12">
              <label className="prop-label">{t("quick_time")}</label>
              <div className="crm-slots">
                {QUICK_SLOTS.map((slot) => (
                  <button
                    key={slot}
                    type="button"
                    className={`crm-slot ${form.time === slot ? "is-active" : ""}`}
                    onClick={() => this.setForm({ time: slot })}
                  >
                    {slot}
                  </button>
                ))}
              </div>
            </div>

            <div className="col-md-6">
              <label className="prop-label">
                {t("owner_admin")} <span className="text-danger">*</span>
              </label>
              {/* พาร์ตเนอร์พาลูกค้าไปชมทรัพย์เอง ช่องนี้จึงเป็นข้อความล็อกไว้ ไม่ใช่ dropdown
                  ชื่อดึงจากรายชื่อผู้ดูแลก่อน (เผื่อนัดเก่าที่คนอื่นดูแลอยู่)
                  ยังโหลดรายชื่อไม่เสร็จค่อยใช้ชื่อในโปรไฟล์ตัวเอง */}
              {self ? (
                <input
                  type="text"
                  className="prop-field"
                  value={this.adminOf(form.admin_uid)?.full_name || self.full_name || ""}
                  disabled
                  readOnly
                />
              ) : (
                <Select
                  className="prop-field prop-select"
                  default={false}
                  placeholder={t("select_agent")}
                  value={form.admin_uid}
                  options={this.adminOptions()}
                  onChange={(value) => value && this.setForm({ admin_uid: value })}
                />
              )}
            </div>
            <div className="col-md-6">
              <label className="prop-label">{t("status")}</label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("status")}
                value={form.status}
                options={APPOINTMENT_STATUSES.map((s) => ({ value: s.value, label: t(s.label) }))}
                onChange={(value) => value && this.setForm({ status: value })}
              />
            </div>

            <div className="col-12">
              <label className="prop-label">{t("meeting_point")}</label>
              <input
                type="text"
                className="prop-field"
                placeholder={t("meeting_point_placeholder")}
                value={form.location}
                onChange={(e) => this.setForm({ location: e.target.value })}
              />
            </div>

            <div className="col-12">
              <label className="prop-label">{t("note")}</label>
              <textarea
                className="crm-textarea"
                placeholder={t("appointment_note_placeholder")}
                value={form.note}
                onChange={(e) => this.setForm({ note: e.target.value })}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-between gap-2">
          <div>
            {!!edit_uid && (
              <button
                type="button"
                className="prop-btn prop-btn--ghost"
                style={{ borderColor: "#fecaca", color: "#b91c1c" }}
                onClick={() => this.Delete(this.state.appointments.find((e) => e.uid === edit_uid))}
              >
                <span className="icon text-12">{""}</span>
                {t("delete_data")}
              </button>
            )}
          </div>
          <div className="d-flex gap-2">
            <button type="button" className="prop-btn prop-btn--ghost" onClick={() => this.setState({ modal_form: false })}>
              {t("cancel")}
            </button>
            <button type="button" className="prop-btn" onClick={this.Save}>
              <span className="icon text-12">{""}</span>
              {t("save")}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  };

  /* ========================================== render : กล่องดูรายละเอียดนัด */
  renderViewModal = () => {
    const { modal_view } = this.state;
    const item = this.current();
    if (!item) return null;

    const type = apptTypeMeta(item.type);
    const status = apptStatusMeta(item.status);
    // ลูกค้า/ทรัพย์ติดมากับนัดหมายจาก API แล้ว ไม่ต้องไปหาจากรายการตัวเลือกซ้ำอีกรอบ
    const customer = item.customer;
    const property = item.asset;

    const kv = (label, value) => (
      <div className="crm-kv">
        <span className="crm-kv__label">{label}</span>
        <span className="crm-kv__value">{value}</span>
      </div>
    );

    return (
      <Modal
        size="lg"
        show={modal_view}
        onHide={() => this.setState({ modal_view: false })}
        centered
        contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
      >
        <Modal.Body className="p-0 bg-white">
          <div className="crm-hero">
            <div className="d-flex align-items-start gap-3 position-relative" style={{ zIndex: 1 }}>
              <span
                className="crm-prop__icon icon"
                style={{ backgroundColor: "rgba(163,230,53,.16)", color: "#a3e635", width: "56px", height: "56px", fontSize: "20px" }}
              >
                {type.icon}
              </span>
              <div className="min-w-0 flex-grow-1">
                <h5 className="fw-bold mb-1 text-truncate">{t(type.label)}</h5>
                <div className="crm-hero__sub mb-2">
                  {item.code} · {dateText(item.start_at)} · {rangeText(item)}
                </div>
                <div className="d-flex flex-wrap gap-2">
                  <span className="crm-badge" style={{ backgroundColor: status.tint, borderColor: status.line, color: status.color }}>
                    <span className="icon">{status.icon}</span>
                    {t(status.label)}
                  </span>
                  {item.reminded && (
                    <span className="crm-badge" style={{ backgroundColor: "rgba(255,255,255,.12)", borderColor: "rgba(255,255,255,.2)", color: "#fff" }}>
                      <span className="icon">{""}</span>
                      {t("reminder_on")}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="p-4" style={{ backgroundColor: "#f6f8f3" }}>
            <div className="row g-3">
              <div className="col-md-6">
                <div className="crm-panel h-100">
                  <div className="crm-panel__head">
                    <span>
                      <span className="icon me-2 text-10">{""}</span>
                      {t("customer")}
                    </span>
                    <button type="button" className="prop-link" onClick={() => this.GoCustomer(item)}>
                      {t("view_details")}
                    </button>
                  </div>
                  <div className="crm-panel__body py-2">
                    <div className="d-flex align-items-center gap-3 mb-2">
                      <div className="ppl-avatar" style={{ background: avatarTone(customer?.email || item.customer_name) }}>
                        {initials(item.customer_name)}
                      </div>
                      <div className="min-w-0">
                        <div className="fw-bold text-dark text-truncate">{item.customer_name}</div>
                        <div className="ppl-sub">{customer?.code || "-"}</div>
                      </div>
                    </div>
                    {kv(t("phone"), fmtPhone(item.customer_phone))}
                    {kv(t("email"), customer?.email || "-")}
                    {kv(t("owner_admin"), item.admin_name || "-")}
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="crm-panel h-100">
                  <div className="crm-panel__head">
                    <span>
                      <span className="icon me-2 text-10">{""}</span>
                      {t("property")}
                    </span>
                  </div>
                  <div className="crm-panel__body py-2">
                    {!!property && (
                      <>
                        {/* รูปหลักของทรัพย์ — ยังไม่มีรูปจะขึ้นพื้นไล่เฉดตามประเภทพร้อมไอคอนแทน */}
                        <div
                          className="mb-2 d-flex align-items-center justify-content-center"
                          style={{
                            height: "150px",
                            borderRadius: "12px",
                            overflow: "hidden",
                            background: property.asset_category?.grad || propTypeMeta(property.type).grad,
                          }}
                        >
                          {property.image ? (
                            <img
                              src={property.image}
                              alt={property.title}
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                          ) : (
                            <span className="icon" style={{ fontSize: "28px", color: "#fff", opacity: 0.85 }}>
                              {property.asset_category?.icon || propTypeMeta(property.type).icon}
                            </span>
                          )}
                        </div>
                        <div className="crm-prop mb-2">
                          <div className="min-w-0">
                            <div className="crm-prop__title text-truncate">{property.title}</div>
                            <div className="crm-prop__meta text-truncate">
                              {property.code} · {property.zone}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {kv(t("meeting_point"), item.location || "-")}
                    {kv(t("duration"), `${item.duration} ${t("unit_minutes")}`)}
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="crm-panel">
                  <div className="crm-panel__head">
                    <span>
                      <span className="icon me-2 text-10">{""}</span>
                      {t("note")}
                    </span>
                  </div>
                  <div className="crm-panel__body">
                    <div className="text-12" style={{ color: "#47524c", lineHeight: 1.6 }}>{item.note || "-"}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        {/* กล่องนี้เป็นหน้าต่าง "ดูข้อมูล" อย่างเดียว — แก้ไข เปลี่ยนสถานะ และลบ ทำที่ปุ่ม
            ของแต่ละแถวในตาราง จึงเหลือแค่ปุ่มปิด */}
        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={() => this.setState({ modal_view: false })}>
            {t("close")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    const { view } = this.state;

    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          {/* หัวข้อหน้า */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("appointments")}</h3>
              <div className="text-secondary text-14">{t("appointments_subtitle")}</div>
            </div>
            <div className="d-flex flex-wrap gap-2">
              <button type="button" className="prop-btn" onClick={() => this.OpenCreate()}>
                <span className="icon text-14">{""}</span>
                {t("add_appointment")}
              </button>
            </div>
          </div>

          {this.renderSummary()}
          {this.renderToolbar()}
          {this.renderResults()}
          {view !== "list" && this.renderMonthBar()}

          {view === "list" ? (
            this.renderList()
          ) : (
            <>
              {this.renderMonth()}
              {this.renderDayPanel()}
            </>
          )}
        </div>

        {this.renderFormModal()}
        {this.renderViewModal()}
      </div>
    );
  }
}

export default withRouter(Appointments);
